export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_c2a1f4d9-e867-4573-92b0-2eba5585ad81/artifacts/eteddesg_E5F3D523-7740-43F0-BC73-182C6A797AE5.png";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/property-maintenance", label: "Property" },
  { to: "/garden-maintenance", label: "Garden" },
  { to: "/clearance", label: "Clearance" },
  { to: "/seasonal", label: "Seasonal" },
  { to: "/landlords", label: "Landlords" },
  { to: "/sourcing", label: "Sourcing" },
  { to: "/story", label: "Our Story" },
  { to: "/contact", label: "Contact" },
];

export const CONTACT = {
  phone: "07576 639731",
  phoneRaw: "07576639731",
  email: "bitternpropertyservices@gmail.com",
  coverage: "Norfolk · parts of Cambridgeshire & Lincolnshire",
};

export const KEY_TOWNS = [
  "Norwich",
  "Great Yarmouth",
  "King's Lynn",
  "Thetford",
  "Cromer",
  "Sheringham",
  "Dereham",
  "Wymondham",
  "Fakenham",
  "Diss",
  "Wisbech",
  "Peterborough",
  "Spalding",
  "Boston",
];

export const IMAGES = {
  homeHero:
    "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBtb2Rlcm4lMjBob3VzZSUyMGV4dGVyaW9yfGVufDB8fHx8MTc4MzQ1MTAyMHww&ixlib=rb-4.1.0&q=85",
  reeds:
    "https://images.unsplash.com/photo-1560763419-4ed11ac0910b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxub3Jmb2xrJTIwcmVlZGJlZHMlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzgzNDUxMDIwfDA&ixlib=rb-4.1.0&q=85",
  repair:
    "https://images.unsplash.com/photo-1562259929-b4e1fd3aef09?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwcHJvcGVydHklMjBtYWludGVuYW5jZSUyMGhvbWUlMjByZXBhaXJ8ZW58MHx8fHwxNzgzNDUxMDIxfDA&ixlib=rb-4.1.0&q=85",
  garden:
    "https://images.unsplash.com/photo-1700689807667-82630348b301?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxwcm9mZXNzaW9uYWwlMjBnYXJkZW4lMjBsYW5kc2NhcGluZ3xlbnwwfHx8fDE3ODM0NTEwMjF8MA&ixlib=rb-4.1.0&q=85",
  wetlands:
    "https://images.unsplash.com/photo-1630765579373-6d225cbc0767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxub3Jmb2xrJTIwcmVlZGJlZHMlMjBsYW5kc2NhcGV8ZW58MHx8fHwxNzgzNDUxMDIwfDA&ixlib=rb-4.1.0&q=85",
  interior:
    "https://customer-assets.emergentagent.com/job_bittern-estates/artifacts/yi8l18wa_BLOG_HEADER.webp",
  hedge:
    "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?auto=format&fit=crop&w=1600&q=80",
  clearance:
    "https://customer-assets-agu9un31.emergentagent.net/job_bittern-estates/artifacts/6gy84f0i_IMG_4214.jpeg",
  snow:
    "https://customer-assets-agu9un31.emergentagent.net/job_bittern-estates/artifacts/sv6si2vx_IMG_4213.jpeg",
  christmas:
    "https://customer-assets-agu9un31.emergentagent.net/job_bittern-estates/artifacts/popwsslm_IMG_4212.jpeg",
  autumnLeaves:
    "https://customer-assets.emergentagent.com/job_bittern-estates/artifacts/dmukwf33_15698435755_fd1f047549_c.jpg",
  cottage:
    "https://customer-assets.emergentagent.com/job_bittern-estates/artifacts/jphn7c5h_IMG_3894.webp",
  toolBelt:
    "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1600&q=80",
};
